exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.policy-sivi-messages > .ant-collapse > .ant-collapse-item > .ant-collapse-header[data-v-63d42042] {\n  background-color: #6ccbd7;\n  border-bottom-color: #38b9c9;\n  color: white;\n}\n", ""]);

// exports
